module.exports = __webpack_public_path__ + "01_long_brown.fca5ed54.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/01_long_brown.png
// module id = aIG7
// module chunks = 0